import { useMediaQuery } from "react-responsive";

const useIsMobile = (maxWidth) => {
  const widthThreshold = maxWidth || 767;

  const byViewportWidth = useMediaQuery({ maxWidth: widthThreshold });

  if (byViewportWidth) {
    return true;
  }

  return false;
};

export default useIsMobile;